var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSetting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-setting",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "wrench-solid",
    d: "M17.847,3.837a.422.422,0,0,0-.707-.194L14.526,6.257l-2.386-.4-.4-2.386L14.356.859a.423.423,0,0,0-.2-.709,5.038,5.038,0,0,0-6,6.508l-7.5,7.5a2.25,2.25,0,1,0,3.182,3.182l7.5-7.5a5.046,5.046,0,0,0,6.514-6.01ZM2.248,16.6a.844.844,0,1,1,.844-.844A.844.844,0,0,1,2.248,16.6Z",
    transform: "translate(0.003 -0.001)",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSetting);
export default __webpack_public_path__ + "static/media/ic-setting.bd638106b4e2f72e17b0df0d36241dba.svg";
export { ForwardRef as ReactComponent };